import MarqueeLib from "react-fast-marquee";
import { Sprout } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const Marquee = () => {
  const { t, lang } = useLanguage();
  const items = t("marquee_items");
  return (
    <div className="bg-[#C4D7D1]/60 border-y border-[#E2E8E4] py-6" data-testid="editorial-marquee">
      <MarqueeLib speed={28} gradient={false} pauseOnHover key={lang}>
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-24 mr-24">
            <span className="font-display italic text-2xl sm:text-3xl text-[#1E352A] whitespace-nowrap">{item}</span>
            <Sprout size={20} className="text-[#F4A261]" />
          </span>
        ))}
      </MarqueeLib>
    </div>
  );
};

export default Marquee;
